import { render, staticRenderFns } from "./shopMarketing.vue?vue&type=template&id=52d9cd30&scoped=true&"
import script from "./shopMarketing.vue?vue&type=script&lang=js&"
export * from "./shopMarketing.vue?vue&type=script&lang=js&"
import style0 from "./shopMarketing.vue?vue&type=style&index=0&id=52d9cd30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9cd30",
  null
  
)

export default component.exports